// @ts-ignore
import cookies from 'js-cookie';
import { isMeta } from '../index';
const anonymousId = cookies.get('grx_unique_id') || cookies.get('optimizelyId');
const SEGMENT_OVERRIDES = {
  context: {
    ip: '0.0.0.0',
    Optimizely: {
      userId: anonymousId
    }
  }
};
export const trackEvent = (event, eventData = {}, options = {}) => {
  // @ts-ignore
  if (window.analytics && typeof window.analytics.track === 'function') {
    try {
      // @ts-ignore
      window.analytics.track(event, updateEventProps(eventData), { ...options,
        ...SEGMENT_OVERRIDES
      });
    } catch (error) {
      console.log(error); // eslint-disable-line no-console
    }
  } else {
    trackDataLayer(event, eventData);
  }
};
/**
 * Rewrite Segment trackLink as we can not pass context there
 * https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#track-link
 * @param link
 * @param event
 * @param eventData
 */

export const trackLink = (link, event, eventData = {}) => {
  if (!link || typeof link !== 'object' || link.nodeName !== 'A' || !event) {
    return;
  }

  link.addEventListener('click', e => {
    const href = link.getAttribute('href') || link.getAttributeNS('http://www.w3.org/1999/xlink', 'href') || link.getAttribute('xlink:href');
    trackEvent(event, eventData);

    if (href && link.target !== '_blank' && !isMeta(e)) {
      e.preventDefault ? e.preventDefault() : e.returnValue = false;
      setTimeout(() => window.location.href = href, 300);
    }
  });
};

const updateEventProps = (eventData = {}) => ({ ...eventData,
  partner: window && window.location.host.includes('.goodrx.com') ? 'goodrx' : 'heydoctor',
  codebase: 'x-content'
});

const trackDataLayer = (event, eventData = {}) => {
  // @ts-ignore
  window.dataLayer = window.dataLayer || []; // @ts-ignore

  window.dataLayer.push({
    event,
    eventData
  });
};